export default class Result {
    constructor(apiResult) {
        this.transformApiResult(apiResult);
    }

    /**
     * Takes in an API result and converts it into a Result object.
     * @param apiResult
     */
    //TODO needs to be filled in
    transformApiResult(apiResult) {
        this.displayText = apiResult['attributes']['Des_Addres'];
        this.objectId = apiResult['attributes']['OBJECTID'];
        this.metaData = apiResult;
    }
}
